import { withTranslation } from "next-i18next";
import { useState } from "react";
import Button from "@components/core/Button";
import Link from "@components/core/Link";
import ProductImage from "@components/core/ProductImage";
import { postProductToUserList } from "@utils/call-api/userlists-call";

function SuggestedProductCard({ userListUuid, product, onProductAddedToUserList, t }) {
  const [loading, setLoading] = useState(false);

  async function addProductToUserList() {
    setLoading(true);
    await postProductToUserList(userListUuid, { product_id: product.id });
    onProductAddedToUserList(product.id);
  }

  return (
    <div className="userlist-suggested-products-slider-card">
      <Link href={`/products/${product.slug}`}>
        <ProductImage
          src={product.main_picture_url}
          sizes="(max-width: 576px) 256px,
          (max-width: 768px) 320px,
          256px"
          className="image-container"
        />
      </Link>
      <div className="w-100">
        <Button
          variant="ghost-primary"
          fullWidth
          onClick={addProductToUserList}
          loading={loading}
          className="px-1"
        >
          {t("catalog:userlist.wishlist.add_to_list")}
        </Button>
      </div>
    </div>
  );
}

export default withTranslation("catalog")(SuggestedProductCard);
